import React from 'react'

interface TabMenuProps {
  children?: React.ReactNode | React.ReactNode[] | null;
}

const TabMenu: React.FC<TabMenuProps> = ({ children }) => {
  return (
    <div id="menu">
      <ul>
        {children}
      </ul>
    </div>
  );
};

export default TabMenu;